<template>
  <div class="table-form form" v-if="$route.query.reportFillType == 'y'">
    <el-form :model="form" ref="ruleForm" label-width="230px" class="ruleForm">
      <el-form-item label="企业名称" style="width: 100% !important">
        <el-input v-model="form.institutionName" :disabled="disable"></el-input>
      </el-form-item>

      <el-form-item label="统一社会信用代码">
        <el-input v-model="form.socialCreditCode" :disabled="disable"></el-input>
      </el-form-item>

      <el-form-item label="新注册或迁入时间">
        <el-date-picker
          v-model="form.registedTime"
          type="date"
          placeholder="选择日期"
          :disabled="disable"
          value-format="yyyy-MM-dd"
        ></el-date-picker>
      </el-form-item>

      <el-form-item label="法定代表人/执行事务合伙人(委派代表)">
        <el-input v-model="form.legalName" :disabled="disable"></el-input>
      </el-form-item>

      <el-form-item label="联系电话">
        <el-input v-model="form.legalTel" :disabled="disable"></el-input>
      </el-form-item>

      <el-form-item label="联系人及职务">
        <el-input v-model="form.linkmanName" :disabled="disable"></el-input>
      </el-form-item>

      <el-form-item label="联系电话">
        <el-input v-model="form.linkmanTel" :disabled="disable"></el-input>
      </el-form-item>

      <el-form-item label="认缴出资额(万元)">
        <el-input v-model="form.manageFundAdmitted" :disabled="disable"></el-input>
      </el-form-item>

      <el-form-item label="实缴出资额(万元)">
        <el-input v-model="form.manageFundPaid" :disabled="disable"></el-input>
      </el-form-item>

      <!-- <el-form-item label="资产总额(万元)">
        <el-input v-model="form.capitalTotal" :disabled="disable"></el-input>
      </el-form-item> -->

      <el-form-item label="企业员工数量(不包含兼职)">
        <el-input v-model="form.staffCount" :disabled="disable"></el-input>
      </el-form-item>

      <el-form-item label="累计纳税金额(万元)">
        <el-input v-model="form.taxTotal" :disabled="disable"></el-input>
      </el-form-item>
      <el-form-item label="是否为政府出资产业投资基金">
        <el-select v-model="instructions.iszfczcytzjj" :disabled="disable">
          <el-option v-for="item in optionsStr" :key="item.value" :label="item.label" :value="item.value"> </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="是否为政府投资基金">
        <el-select v-model="instructions.iszftzjj" :disabled="disable">
          <el-option v-for="item in optionsStr" :key="item.value" :label="item.label" :value="item.value"> </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="LP个人投资者数量">
        <el-input v-model="instructions.lpgrtzzsl" :disabled="disable"></el-input>
      </el-form-item>
      <el-form-item label="LP个人投资者金额（万元）">
        <el-input v-model="instructions.lpgrtzzje" :disabled="disable"></el-input>
      </el-form-item>
      <el-form-item label="LP机构投资者数量">
        <el-input v-model="instructions.lpjgtzzsl" :disabled="disable"></el-input>
      </el-form-item>
      <el-form-item label="LP机构投资者金额（万元）">
        <el-input v-model="instructions.lpjgtzzje" :disabled="disable"></el-input>
      </el-form-item>
      <!-- <el-form-item label="管理基金数量">
        <el-input v-model="instructions.gljjsl" :disabled="disable"></el-input>
      </el-form-item>
      <el-form-item label="管理基金规模（万元）">
        <el-input v-model="instructions.gljjgm" :disabled="disable"></el-input>
      </el-form-item> -->
      <el-form-item label="实际办公地址" style="width: 100% !important">
        <el-input v-model="form.realAddress" :disabled="disable"></el-input>
      </el-form-item>
      <el-form-item label="是否已完成中基协登记/备案" class="register">
        <el-select v-model="form.associtionRegisted" placeholder="请选择" @change="changeRegister" :disabled="disable">
          <el-option
            :value="item.value"
            :label="item.label"
            v-for="(item, index) of optionsNum"
            :key="index"
          ></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="基金管理人" v-if="isShow">
        <el-input v-model="form.fundManager"></el-input>
      </el-form-item>
      <!--已登记-->
      <el-form-item label="登记时间" v-if="isRegister">
        <el-date-picker
          v-model="form.associtionRegistedTime"
          type="date"
          placeholder="选择日期"
          :disabled="disable"
          value-format="yyyy-MM-dd"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="登记编号" v-if="isRegister">
        <el-input v-model="form.registedNo" :disabled="disable"></el-input>
      </el-form-item>
      <!--未登记 未办理-->
      <el-form-item label="是否办理中" v-if="!isRegister">
        <el-select v-model="form.isRegisting" placeholder="请选择" @change="changeTransact" :disabled="disable">
          <el-option
            :value="item.value"
            :label="item.label"
            v-for="(item, index) of optionsNum"
            :key="index"
          ></el-option>
        </el-select>
      </el-form-item>
      <!--  -->
      <el-form-item label="具体登记进展" v-if="!isRegister && transact">
        <el-input v-model="form.registeProgress" :disabled="disable"></el-input>
      </el-form-item>
      <el-form-item label="预计完成时间" v-if="!isRegister && transact">
        <el-date-picker
          v-model="form.registePlanTime"
          type="date"
          placeholder="选择日期"
          :disabled="disable"
          value-format="yyyy-MM-dd"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="本月实缴资本出资情况及时间" style="width: 100% !important">
        <el-input type="textarea" v-model="form.capitalPaidSituation" :disabled="disable"></el-input>
      </el-form-item>
    </el-form>
  </div>
  <div class="table-form form" v-else>
    <el-form :model="form" ref="ruleForm" label-width="230px" class="ruleForm">
      <el-form-item label="企业名称" style="width: 100% !important">
        <el-input v-model="form.institutionName" :disabled="disable"></el-input>
      </el-form-item>

      <el-form-item label="统一社会信用代码">
        <el-input v-model="form.socialCreditCode" :disabled="disable"></el-input>
      </el-form-item>

      <el-form-item label="新注册或迁入时间">
        <el-date-picker
          v-model="form.registedTime"
          type="date"
          placeholder="选择日期"
          :disabled="disable"
          value-format="yyyy-MM-dd"
        ></el-date-picker>
      </el-form-item>

      <el-form-item label="法定代表人/执行事务合伙人(委派代表)">
        <el-input v-model="form.legalName" :disabled="disable"></el-input>
      </el-form-item>

      <el-form-item label="联系电话">
        <el-input v-model="form.legalTel" :disabled="disable"></el-input>
      </el-form-item>

      <el-form-item label="联系人及职务">
        <el-input v-model="form.linkmanName" :disabled="disable"></el-input>
      </el-form-item>

      <el-form-item label="联系电话">
        <el-input v-model="form.linkmanTel" :disabled="disable"></el-input>
      </el-form-item>

      <el-form-item label="认缴出资额(万元)">
        <el-input v-model="form.manageFundAdmitted" :disabled="disable"></el-input>
      </el-form-item>

      <el-form-item label="实缴出资额(万元)">
        <el-input v-model="form.manageFundPaid" :disabled="disable"></el-input>
      </el-form-item>

      <!-- <el-form-item label="资产总额(万元)">
        <el-input v-model="form.capitalTotal" :disabled="disable"></el-input>
      </el-form-item> -->

      <el-form-item label="是否为政府出资产业投资基金">
        <el-select v-model="instructions.iszfczcytzjj" :disabled="disable">
          <el-option v-for="item in optionsIs" :key="item.value" :label="item.label" :value="item.value"> </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="是否为政府投资基金">
        <el-select v-model="instructions.iszftzjj" :disabled="disable">
          <el-option v-for="item in optionsIs" :key="item.value" :label="item.label" :value="item.value"> </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="管理基金数量">
        <el-input v-model="instructions.gljjsl" :disabled="disable"></el-input>
      </el-form-item>
      <el-form-item label="管理基金规模（万元）">
        <el-input v-model="instructions.gljjgm" :disabled="disable"></el-input>
      </el-form-item>
      <el-form-item label="企业员工数量(不包含兼职)">
        <el-input v-model="form.staffCount" :disabled="disable"></el-input>
      </el-form-item>
      <el-form-item label="累计纳税金额(万元)">
        <el-input v-model="form.taxTotal" :disabled="disable"></el-input>
      </el-form-item>
      <el-form-item label="实际办公地址" style="width: 100% !important">
        <el-input v-model="form.realAddress" :disabled="disable"></el-input>
      </el-form-item>
      <el-form-item label="是否已完成中基协登记/备案" class="register">
        <el-select v-model="form.associtionRegisted" placeholder="请选择" @change="changeRegister" :disabled="disable">
          <el-option
            :value="item.value"
            :label="item.label"
            v-for="(item, index) of optionsNum"
            :key="index"
          ></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="基金管理人" v-if="isShow">
        <el-input v-model="form.fundManager"></el-input>
      </el-form-item>
      <!--已登记-->
      <el-form-item label="登记时间" v-if="isRegister">
        <el-date-picker
          v-model="form.associtionRegistedTime"
          type="date"
          placeholder="选择日期"
          :disabled="disable"
          value-format="yyyy-MM-dd"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="登记编号" v-if="isRegister">
        <el-input v-model="form.registedNo" :disabled="disable"></el-input>
      </el-form-item>
      <!--未登记 未办理-->
      <el-form-item label="是否办理中" v-if="!isRegister">
        <el-select v-model="form.isRegisting" placeholder="请选择" @change="changeTransact" :disabled="disable">
          <el-option
            :value="item.value"
            :label="item.label"
            v-for="(item, index) of optionsNum"
            :key="index"
          ></el-option>
        </el-select>
      </el-form-item>
      <!--  -->
      <el-form-item label="具体登记进展" v-if="!isRegister && transact">
        <el-input v-model="form.registeProgress" :disabled="disable"></el-input>
      </el-form-item>
      <el-form-item label="预计完成时间" v-if="!isRegister && transact">
        <el-date-picker
          v-model="form.registePlanTime"
          type="date"
          placeholder="选择日期"
          :disabled="disable"
          value-format="yyyy-MM-dd"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="本季度实缴资本出资情况及时间" style="width: 100% !important">
        <el-input type="textarea" v-model="form.capitalPaidSituation" :disabled="disable"></el-input>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  props: {
    tableData: {
      type: Object,
      default: function () {
        return {}
      }
    },
    disable: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      // 是否已完成中基协登记
      isRegister: false,
      // 是否办理中
      transact: false,
      form: {
        institutionName: '',
        socialCreditCode: '',
        legalTel: '',
        legalName: '',
        linkmanName: '',
        linkmanTel: '',
        manageFundAdmitted: '',
        manageFundPaid: '',
        capitalTotal: '',
        staffCount: '',
        taxTotal: '',
        associtionRegisted: '',
        registedTime: '',
        registedNo: '',
        isRegisting: '',
        associtionRegistedTime: '',
        registeProgress: '',
        registePlanTime: '',
        capitalPaidSituation: '',
        instructions: ''
      },
      options: [
        {
          label: '是',
          value: true
        },
        {
          label: '否',
          value: false
        }
      ],
      optionsStr: [
        {
          label: '是',
          value: '1'
        },
        {
          label: '否',
          value: '0'
        }
      ],
      optionsNum: [
        {
          label: '是',
          value: 1
        },
        {
          label: '否',
          value: 0
        }
      ],
      optionsIs: [
        {
          label: '是',
          value: '是'
        },
        {
          label: '否',
          value: '否'
        }
      ],
      isShow: false,
      instructions: {
        iszfczcytzjj: '',
        iszftzjj: '',
        lpgrtzzsl: '',
        lpgrtzzsl: '',
        lpjgtzzsl: '',
        lpjgtzzje: '',
        gljjsl: '',
        gljjgm: ''
      }
    }
  },
  mounted() {
    if (this.$route.query.institutionCode !== undefined) {
      if (this.$route.query.institutionCode.slice(0, 2) === 'GL') {
        this.isShow = false
      } else {
        this.isShow = true
      }
    }

    this.getData(this.tableData)
  },

  methods: {
    getData(val) {
      if (!Object.keys(val).length) return

      val.registedTime = val.registedTime
        ? this.$moment(val.registedTime).format('YYYY-MM-DD')
        : this.$moment(new Date()).format('YYYY-MM-DD')
      val.registePlanTime = val.registePlanTime
        ? this.$moment(val.registePlanTime).format('YYYY-MM-DD')
        : this.$moment(new Date()).format('YYYY-MM-DD')
      this.form = this.$lodash.cloneDeep(val)
      if (this.form.associtionRegisted === 1) {
        this.form.associtionRegisted = '是'
        this.isRegister = true
      } else {
        this.form.associtionRegisted = '否'
        this.isRegister = false
        this.transact = false
      }

      if (this.form.isRegisting === 1) {
        this.form.isRegisting = '是'
        this.transact = true
      } else {
        this.form.isRegisting = '否'
      }
      if (!this.form.instructions) {
        console.log('读取失败')
        this.form.instructions = `{}`
      } else {
        console.log('读取成功', this.form.instructions)
        this.instructions = JSON.parse(this.form.instructions)
      }
      console.log('this.form', this.form)
    },

    changeTransact(val) {
      this.transact = val
    },

    changeRegister(val) {
      this.isRegister = val
    }
  },

  watch: {
    tableData: {
      handler(newValue) {
        this.getData(this.tableData)
      },
      deep: true
    },
    instructions: {
      handler(newVal) {
        this.form.instructions = JSON.stringify(newVal)
      },
      deep: true
    }
  }
}
</script>

<style scoped>
.register {
  /* border-bottom: 1px solid #e1e1e1 !important; */
}

.form {
  margin-top: 20px;
}
.table-form >>> .el-form-item .el-form-item__label {
  height: 54px !important;
}
</style>
